<app-join-community [memberState]="data?.memberState" [admins]="data?.admins"
    [user]="data?.user" [community]="data?.community" [isMobile]="false" (close)="close($event)"
></app-join-community>
